import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;

  Math.clamp = function (a, b, c) { return Math.max(b, Math.min(c, a)); };
  Math.map = function (v, l1, h1, l2, h2) { return l2 + (h2 - l2) * (v - l1) / (h1 - l1); };
  document.getElementById('gun-SEL1').addEventListener('input', function () {
    const r = document.getElementById(`ccl_${this.selectedIndex}`).getAttribute('r');
    document.getElementById('ctArc').setAttribute('r', r);
    document.getElementById('ctTar').textContent = this.options[this.selectedIndex].text;
    document.getElementById('ctNumT').textContent = this.value;
    document.getElementById('ctNum').style.transform = `translate(0,${(500 - r) - 20}px)`;// ('',);
  });
  function gn_xmrk(th, e) {
    document.getElementById('gnsx-ctry').innerHTML = th.getAttribute('data-t');
    document.getElementById('gnsx-val').innerHTML = th.getAttribute('data-a');
    const ppb = document.getElementById('popBox2');
    ppb.style.top = `${e.offsetY}px`;
    ppb.style.left = `${e.offsetX}px`;
    ppb.classList.add('inV');
  }
  function drawAll() {
    document.querySelectorAll('#gun-SEL1>option').forEach((a, b) => {
      const iA = Math.pow(a.value, 2) * Math.PI;
      const aA = Math.pow(120.5, 2) * Math.PI;
      const tA = Math.pow(440, 2) * Math.PI;
      document.getElementById('allCircles').innerHTML += `<circle id="ccl_${b}" data-a="${a.value}"  data-t="${a.text}" cx="50%" cy="500" r="${Math.map(Math.sqrt(tA * (iA / aA) / Math.PI), 0, 316, 0, 440)}"/>`;
    });
    document.querySelectorAll('#allCircles>circle').forEach((a, b) => {
      a.addEventListener('mouseenter', function (e) {
        gn_xmrk(this, e);
      });
      a.addEventListener('mouseleave', (e) => {
        document.getElementById('popBox2').classList.remove('inV');
      });

      a.addEventListener('click', function () {
        const r = this.getAttribute('r');
        document.getElementById('ctArc').setAttribute('r', r);
        document.getElementById('ctTar').textContent = this.getAttribute('data-t');
        document.getElementById('ctNumT').textContent = this.getAttribute('data-a');
        document.getElementById('ctNum').style.transform = `translate(0,${(500 - r) - 20}px)`;// ('',);
      });
    });
  }
  drawAll();
}
